import React from "react";
import { FC } from "react";
import { FullScreenLoader } from "../Components/Loader";
import Button from "@mui/material/Button";

interface IProps {
  show: boolean;
  title?: string;
  message?: string;
  children?: any;
  onConfirm?: Function;
  onClose?: Function;
  loading?: boolean;
  disableSubmit?: boolean;
}

export const Popup: FC<IProps> = ({
  show,
  title,
  message,
  children,
  onConfirm,
  onClose,
  loading,
  disableSubmit,
}) => {
  if (!show) return null;

  return (
    <div className="popup">
      <div className="popup-inner">
        {title && <h3>{title}</h3>}
        {message && <p>{message}</p>}
        {children && <div>{children}</div>}
        <div className="button-container">
          <Button onClick={() => onClose && onClose()} variant="outlined">
            Close
          </Button>
          {onConfirm && (
            <Button
              onClick={() => onConfirm()}
              type="submit"
              variant="contained"
              disabled={disableSubmit}
              style={{ marginLeft: "10px" }}
            >
              Confirm
            </Button>
          )}
        </div>
        {loading && <FullScreenLoader isLoading />}
      </div>
    </div>
  );
};

export default Popup;
